var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ direction: _vm.$vs.rtl ? 'rtl' : 'ltr' })},[(_vm.params.Count > 0)?_c('span',{staticClass:"mouse-pointer",on:{"click":function($event){return _vm.filterAttendeeListByLocationId(_vm.params.LocationId)}}},[_vm._v(_vm._s(_vm.params.Count))]):_c('span',[_vm._v("0")])])
}
var staticRenderFns = []

export { render, staticRenderFns }